import { useState } from 'react';
import { DatePicker, Modal, Select } from 'antd';
import ComposeMail from '../../../../../components/EmailEditor/ComposeEmailEditor';
import calender from "../../../../../assets/images/calender-week.svg"
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

// Define the props type for the component
interface ComposeMailModalProps {
  title: string; // Title of the modal
  sendMail: boolean; // State to control modal visibility
  actionType: string;
  [key: string]: any;
}

const dropDownList = [
  { value: "Career growth and better opportunities", label: "Career growth and better opportunities" },
  { value: "Personal reasons", label: "Personal reasons" },
  { value: "Workplace-related reasons", label: "Workplace-related reasons" },
  { value: "Higher studies and skill enhancement", label: "Higher studies and skill enhancement" },
  { value: "Compensation and benefits", label: "Compensation and benefits" },
  { value: "Organizational changes", label: "Organizational changes" },
];


function ComposeMailModal(props: Readonly<ComposeMailModalProps>) {
  const { title, handelCancel, sendMail } = props;
  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const [values, setValues] = useState({ reason: "", resignDate: dayjs().format("YYYY-MM-DD"), relievingDate: dayjs().add(60, "day").format("YYYY-MM-DD") });
  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  const handleReasonsChange = (value: any, label: any) => {
    setValues({ ...values, reason: value });
  };

  return (
    <div>
      <Modal
        title={title}
        className="new-message_requestion w-[1200px]"
        centered
        open={sendMail}
        onOk={() => handelCancel()}
        onCancel={() => handelCancel()}
        footer={null}
        maskClosable={false}
      >
        <div className="flex items-baseline w-full md:pt-6 pt-0 mt-8 pb-3 md:pl-4 pl-0 details-box">
          <div className="w-[60%] details-row">
            <div className="flex w-full pb-4 label-box">
              <p className='text-[16px] w-[30%] font-rubik text-[#878787] label-text'>Employee name </p>
              <span className=' hidden md:block'>:</span>
              <div className='md:w-[70%] w-[190px]'>
                <span className='block text-[16px] md:px-6 px-0 font-rubik font-medium text-[#333333] label-data'> {employeeDetails?.firstName + " " + employeeDetails?.lastName}</span>
              </div>
            </div>

            <div className="flex items-center w-full pb-4 label-box">
              <p className='text-[16px] w-[30%] font-rubik text-[#878787] label-text'>Reason for Relieving* </p> <span className=' hidden md:block'>:</span>
              <div className='w-[50%] md:pl-6 pl-0'>
                <Select className='float-control w-full __select-kt font-rubik' options={dropDownList} onChange={handleReasonsChange} showSearch filterOption={filterOption} placeholder="Select reason" optionFilterProp="children"
                  suffixIcon={<span className=" text-[#000] material-symbols-outlined" >  arrow_drop_down </span>} />
              </div>
            </div>


          </div>
          <div className="w-[40%] details-row flex justify-center items-center date_picker flex-col">
            <div className="flex items-center w-full pb-4 label-box">
              <p className='text-[16px] md:w-[180px] w-[50%]  font-rubik text-[#878787] label-text'>Resignation date &nbsp; &nbsp; &nbsp; <span className=' hidden md:inline'>:</span> </p>
              <div className='md:w-[190px] md-[30%]'>
                <DatePicker
                  suffixIcon={<img src={calender} className='mb-2' />}
                  placeholder='Select resignation date'
                  name='resignation-date'
                  className='float-control w-full'
                  format="DD/MM/YYYY"
                  value={
                    values?.resignDate
                      ? dayjs(values?.resignDate) // ISO string — no need for custom format
                      : null
                  }
                  disabled
                />
              </div>
            </div>

            <div className="flex items-center w-full pb-4 label-box">
              <p className='text-[16px] md:w-[180px] w-[50%]  font-rubik text-[#878787] label-text'>Date of Relieving &nbsp; &nbsp; &nbsp; <span className=' hidden md:inline'>:</span> </p>
              <div className='md:w-[190px] md-[30%]'>
                <DatePicker suffixIcon={<img src={calender} className='mb-2' />} placeholder='Select relieving date' className='float-control w-full' format="DD/MM/YYYY"

                  value={
                    values?.relievingDate
                      ? dayjs(values?.relievingDate) // ISO string — no need for custom format
                      : null
                  }
                  disabled />
              </div>

            </div>
          </div>
        </div>

        {/* Email Editor */}
        <ComposeMail
          {...props}
          draftButton={false}
          cancelButton={true}
          submitButtonName="Submit"
          mainToolbar={false}
          textToolBar={true}
          defaultValidation={false}
          customFields={values}
          placeholder="Provide a reason for resignation (optional)..."
        />
      </Modal>
    </div>
  );
}

export default ComposeMailModal;
